import * as React from 'react';

export interface QITIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * QITIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Qualified Income Trust (Miller Trust). QIT-labeled document with Medicaid red cross corner badge.
 */
const QITIcon: React.FunctionComponent<QITIconProps> = ({
  className,
  size = 40,
  title = 'Qualified Income Trust (Miller Trust)',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M10 4 Q10 3 11 3 L32 3 L40 11 L40 43 Q40 44 39 44 L11 44 Q10 44 10 43 Z" fill="#FFFFFF" stroke="#0f7e88" strokeWidth="1.4"/>
      <path d="M32 3 L32 11 L40 11 Z" fill="#0f7e88"/>
      <text x="25" y="24" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="11" fontWeight="900" fill="#0f7e88" letterSpacing="0.5">QIT</text>
      <line x1="14" y1="29" x2="36" y2="29" stroke="#0f7e88" strokeWidth="0.8"/>
      <line x1="14" y1="32" x2="32" y2="32" stroke="#0f7e88" strokeWidth="0.8"/>
      <circle cx="34" cy="38" r="4.5" fill="#a32d4a"/>
      <rect x="33.2" y="35.5" width="1.6" height="5" fill="#FFFFFF"/>
      <rect x="31.5" y="37.2" width="5" height="1.6" fill="#FFFFFF"/>
  </svg>
);

export default QITIcon;
